import { jsx as _jsx } from "react/jsx-runtime";
import Section from './FooterNavSection';
export default function Nav(props) {
    return (_jsx("ul", { className: "grid grid-cols-2 sm:flex sm:space-x-8 md:space-x-14 lg:space-x-24", children: props.sections.map((section) => (_jsx("li", { className: "my-2 sm:my-0", children: _jsx(Section, { section: section }) }, section.title))) }));
}
